import { useEffect, useState, useRef } from "react";
import { Link, useSearchParams } from "react-router-dom";
import Layout from "@/components/Layout";
import { api } from "@/lib/apiClient";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { CheckCircle2, Loader2 } from "lucide-react";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sid = params.get("session_id");
  const [status, setStatus] = useState("pending");
  const [tries, setTries] = useState(0);
  const { refresh } = useAuth();
  const fired = useRef(false);

  useEffect(() => {
    if (!sid) return;
    if (status === "paid" || tries > 15) return;
    const t = setTimeout(async () => {
      try {
        const { data } = await api.get(`/payments/status/${sid}`);
        setStatus(data.payment_status);
        if (data.payment_status === "paid") {
          refresh();
          if (!fired.current && window.gtag) {
            fired.current = true;
            window.gtag("event", "conversion", {
              send_to: "AW-18434067436/fEfQCNmn3u8cEOyXhtZE",
              value: (data.amount || 0) / 100 || 1.0,
              currency: (data.currency || "eur").toUpperCase(),
              transaction_id: sid,
            });
          }
        }
      } catch {}
      setTries(t => t + 1);
    }, 2000);
    return () => clearTimeout(t);
  }, [sid, status, tries, refresh]);

  return (
    <Layout>
      <div className="max-w-2xl mx-auto py-24 px-6 text-center">
        {status === "paid" ? (
          <>
            <CheckCircle2 className="w-20 h-20 text-green-600 mx-auto mb-6" strokeWidth={1.2} />
            <h1 className="text-5xl font-black tracking-tighter mb-4">Pagamento riuscito</h1>
            <p className="text-slate-600 mb-8">Il tuo acquisto è stato accreditato sull'account. Buon allenamento!</p>
            <div className="flex gap-3 justify-center">
              <Link to="/tests"><Button data-testid="ps-tests-btn" className="rounded-none bg-[#002FA7] hover:bg-[#001d6b] label-mono py-6 px-8">Vai ai test</Button></Link>
              <Link to="/dashboard"><Button data-testid="ps-dashboard-btn" variant="outline" className="rounded-none border-slate-900 label-mono py-6 px-8">Dashboard</Button></Link>
            </div>
          </>
        ) : (
          <>
            <Loader2 className="w-16 h-16 text-[#002FA7] mx-auto mb-6 animate-spin" strokeWidth={1.2} />
            <h1 className="text-3xl font-black tracking-tighter mb-4">Verifica pagamento in corso…</h1>
            <p className="text-slate-500 text-sm">Un istante, stiamo confermando la transazione con Stripe.</p>
          </>
        )}
      </div>
    </Layout>
  );
}
